import {
    GET_DASHBOARD_DATA_REQUEST,
    GET_DASHBOARD_DATA_SUCCESS,
    GET_DASHBOARD_DATA_FAILURE,
    UNLOAD_DASHBOARD,
    GET_UPTIME_REQUEST,
    GET_UPTIME_SUCCESS,
    GET_UPTIME_FAILURE,
    GET_SERVICES_STATUS_REQUEST,
    GET_SERVICES_STATUS_SUCCESS,
    GET_SERVICES_STATUS_FAILURE,
    GET_FIREWALL_POLICIES_STATUS_REQUEST,
    GET_FIREWALL_POLICIES_STATUS_SUCCESS,
    GET_FIREWALL_POLICIES_STATUS_FAILURE,
    GET_FIREWALL_SERVICES_STATUS_REQUEST,
    GET_FIREWALL_SERVICES_STATUS_SUCCESS,
    GET_FIREWALL_SERVICES_STATUS_FAILURE,
    GET_WEB_SECURITY_STATUS_REQUEST,
    GET_WEB_SECURITY_STATUS_SUCCESS,
    GET_WEB_SECURITY_STATUS_FAILURE,
    GET_PARTITIONS_STATUS_REQUEST,
    GET_PARTITIONS_STATUS_SUCCESS,
    GET_PARTITIONS_STATUS_FAILURE,
    GET_STORAGE_USAGE_REQUEST,
    GET_STORAGE_USAGE_SUCCESS,
    GET_STORAGE_USAGE_FAILURE,
    GET_ACTIVE_CALLS_REQUEST,
    GET_ACTIVE_CALLS_SUCCESS,
    GET_ACTIVE_CALLS_FAILURE,
    GET_UPDATES_REQUEST,
    GET_UPDATES_SUCCESS,
    GET_UPDATES_FAILURE,
    GET_DEVICES_UPDATES_REQUEST,
    GET_DEVICES_UPDATES_SUCCESS,
    GET_DEVICES_UPDATES_FAILURE,
    GET_WEAK_PASSWORDS_REQUEST,
    GET_WEAK_PASSWORDS_SUCCESS,
    GET_WEAK_PASSWORDS_FAILURE,
    GET_VPN_STATUS_REQUEST,
    GET_VPN_STATUS_SUCCESS,
    GET_VPN_STATUS_FAILURE,
    GET_CALLS_SUMMARY_REQUEST,
    GET_CALLS_SUMMARY_SUCCESS,
    GET_CALLS_SUMMARY_FAILURE,
    GET_TOTAL_CALLS_REQUEST,
    GET_TOTAL_CALLS_SUCCESS,
    GET_TOTAL_CALLS_FAILURE
} from './dashboardActionTypes';

export const getDashboardDataRequest = () => ({ type: GET_DASHBOARD_DATA_REQUEST });

export const getDashboardDataSuccess = () => ({ type: GET_DASHBOARD_DATA_SUCCESS });

export const getDashboardDataFailure = () => ({
    type: GET_DASHBOARD_DATA_FAILURE,
    payload: new Error(),
    error: true
});

export const unloadDashboard = () => ({ type: UNLOAD_DASHBOARD });

export const getUptimeRequest = () => ({ type: GET_UPTIME_REQUEST });

export const getUptimeSuccess = uptime => ({
    type: GET_UPTIME_SUCCESS,
    payload: { uptime }
});

export const getUptimeFailure = () => ({
    type: GET_UPTIME_FAILURE,
    payload: new Error(),
    error: true
});

export const getFirewallPoliciesStatusRequest = () => ({ type: GET_FIREWALL_POLICIES_STATUS_REQUEST });

export const getFirewallPoliciesStatusSuccess = status => ({
    type: GET_FIREWALL_POLICIES_STATUS_SUCCESS,
    payload: { status }
});

export const getFirewallPoliciesStatusFailure = () => ({
    type: GET_FIREWALL_POLICIES_STATUS_FAILURE,
    payload: new Error(),
    error: true
});

export const getFirewallServicesStatusRequest = () => ({ type: GET_FIREWALL_SERVICES_STATUS_REQUEST });

export const getFirewallServicesStatusSuccess = status => ({
    type: GET_FIREWALL_SERVICES_STATUS_SUCCESS,
    payload: { status }
});

export const getFirewallServicesStatusFailure = () => ({
    type: GET_FIREWALL_SERVICES_STATUS_FAILURE,
    payload: new Error(),
    error: true
});

export const getWebSecurityStatusRequest = () => ({ type: GET_WEB_SECURITY_STATUS_REQUEST });

export const getWebSecurityStatusSuccess = status => ({
    type: GET_WEB_SECURITY_STATUS_SUCCESS,
    payload: { status }
});

export const getWebSecurityStatusFailure = () => ({
    type: GET_WEB_SECURITY_STATUS_FAILURE,
    payload: new Error(),
    error: true
});

export const getPartitionsStatusRequest = () => ({ type: GET_PARTITIONS_STATUS_REQUEST });

export const getPartitionsStatusSuccess = status => ({
    type: GET_PARTITIONS_STATUS_SUCCESS,
    payload: { status }
});

export const getPartitionsStatusFailure = () => ({
    type: GET_PARTITIONS_STATUS_FAILURE,
    payload: new Error(),
    error: true
});

export const getStorageUsageRequest = () => ({ type: GET_STORAGE_USAGE_REQUEST });

export const getStorageUsageSuccess = usage => ({
    type: GET_STORAGE_USAGE_SUCCESS,
    payload: { usage }
});

export const getStorageUsageFailure = () => ({
    type: GET_STORAGE_USAGE_FAILURE,
    payload: new Error(),
    error: true
});

export const getServicesStatusRequest = () => ({ type: GET_SERVICES_STATUS_REQUEST });

export const getServicesStatusSuccess = status => ({
    type: GET_SERVICES_STATUS_SUCCESS,
    payload: { status }
});

export const getServicesStatusFailure = () => ({
    type: GET_SERVICES_STATUS_FAILURE,
    payload: new Error(),
    error: true
});

export const getActiveCallsRequest = () => ({ type: GET_ACTIVE_CALLS_REQUEST });

export const getActiveCallsSuccess = calls => ({
    type: GET_ACTIVE_CALLS_SUCCESS,
    payload: { calls }
});

export const getActiveCallsFailure = () => ({
    type: GET_ACTIVE_CALLS_FAILURE,
    payload: new Error(),
    error: true
});

export const getUpdatesRequest = () => ({ type: GET_UPDATES_REQUEST });

export const getUpdatesSuccess = updatesQtty => ({
    type: GET_UPDATES_SUCCESS,
    payload: { updatesQtty }
});

export const getUpdatesFailure = () => ({
    type: GET_UPDATES_FAILURE,
    payload: new Error(),
    error: true
});

export const getDevicesUpdatesRequest = () => ({ type: GET_DEVICES_UPDATES_REQUEST });

export const getDevicesUpdatesSuccess = devicesUpdatesQtty => ({
    type: GET_DEVICES_UPDATES_SUCCESS,
    payload: { devicesUpdatesQtty }
});

export const getDevicesUpdatesFailure = () => ({
    type: GET_DEVICES_UPDATES_FAILURE,
    payload: new Error(),
    error: true
});

export const getWeakPasswordsRequest = () => ({ type: GET_WEAK_PASSWORDS_REQUEST });

export const getWeakPasswordsSuccess = weakPasswordsQtty => ({
    type: GET_WEAK_PASSWORDS_SUCCESS,
    payload: { weakPasswordsQtty }
});

export const getWeakPasswordsFailure = () => ({
    type: GET_WEAK_PASSWORDS_FAILURE,
    payload: new Error(),
    error: true
});

export const getVPNStatusRequest = () => ({ type: GET_VPN_STATUS_REQUEST });

export const getVPNStatusSuccess = vpnStatus => ({
    type: GET_VPN_STATUS_SUCCESS,
    payload: { vpnStatus }
});

export const getVPNStatusFailure = () => ({
    type: GET_VPN_STATUS_FAILURE,
    payload: new Error(),
    error: true
});

export const getCallsSummaryRequest = () => ({ type: GET_CALLS_SUMMARY_REQUEST });

export const getCallsSummarySuccess = summary => ({
    type: GET_CALLS_SUMMARY_SUCCESS,
    payload: { summary }
});

export const getCallsSummaryFailure = () => ({
    type: GET_CALLS_SUMMARY_FAILURE,
    payload: new Error(),
    error: true
});

export const getTotalCallsRequest = () => ({ type: GET_TOTAL_CALLS_REQUEST });

export const getTotalCallsSuccess = calls => ({
    type: GET_TOTAL_CALLS_SUCCESS,
    payload: { calls }
});

export const getTotalCallsFailure = () => ({
    type: GET_TOTAL_CALLS_FAILURE,
    payload: new Error(),
    error: true
});
